<template>
  <div class="flex flex-col min-h-full">
    <topbar :menu="false" title="Benvenuto in lìdate" />
    <div class="flex-grow flex-shrink-0 flex items-center px-4 xl:px-0 mx-auto max-w-2xl w-full" v-once>
      <div class="">
        <div class="flex">
          <div class="p-4 justify-self-center" v-html="icon('survey')"></div>
          <div class="py-2">
            <div class="text-brand-1 font-display font-bold text-lg">Come lo dici?</div>
            <div class="">
              Esistono diversi modi per indicare un oggetto o per esprimere lo stesso concetto. Rispondi ai sondaggi indicando le parole che conosci e quelle che usi abitualmente.
            </div>
          </div>
        </div>

        <div class="flex">
          <div class="p-4 justify-self-center" v-html="icon('maps')"></div>
          <div class="py-2">
            <div class="text-brand-1 font-display font-bold text-lg">Mappe</div>
            <div class="">
              L’italiano, come tutte le lingue, varia a seconda del luogo in cui è parlato. Scopri come sono distribuite le tue espressioni e quelle degli altri utenti. Le mappe linguistiche sono regolarmente aggiornate.
            </div>
          </div>
        </div>

        <div class="flex">
          <div class="p-4 justify-self-center" v-html="icon('quiz')"></div>
          <div class="py-2">
            <div class="text-brand-1 font-display font-bold text-lg">Quiz</div>
            <div class="">
              Una volta al mese puoi mettere alla prova le tue conoscenze in ambito linguistico. Rispondi correttamente alle domande nel minor tempo possibile. 
              Il primo in classifica vince un premio a scelta tra quelli offerti dai nostri <a href="https://sostenitori.lidate.ch" target="_blank" class="underline">sostenitori</a>.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mx-auto max-w-2xl w-full flex-grow-0 xl:flex-grow items-center flex pb-3">
      <div class="flex m-2 w-full ">
        <router-link :to="{name: 'Login'}" class="mr-1 flex-1 btn btn-1">{{$t('start.login')}}</router-link>
        <router-link :to="{name: 'Register'}" class="ml-1 flex-1 btn btn-1">{{$t('subscribe')}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { getIconHtml, icons } from '@/services/icons'

export default {
  methods: {
    icon(icon) {
      return getIconHtml(icons[icon], 45)
    }
  }
}
</script>
